angular.module('gestioneAttiApp').directive('improcedibileBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/improcedibileBlock/improcedibileBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            improcedibile: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            hideEsitoAttoMedatati: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.improcedibile = {visible: true};

            vm.sezioni = {
                IMPROCEDIBILE: {
                    form: 'app/components/improcedibileBlock/improcedibile.html'
                }
            };

            vm.stato = {
                improcedibile: {
                    isCollapsed: vm.statoAttoCorrente === 'IMPROCEDIBILE' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});
